import {
  BUSINESS_DAY_DELETED,
  BUSINESS_DAY_LIST_LOADED,
  BUSINESS_DAY_LOADED,
  BUSINESS_DAY_SAVED,
  LOAD_BUSINESS_DAY,
  LOAD_BUSINESS_DAY_LIST,
  RESET_BUSINESS_DAY,
  RESET_BUSINESS_DAY_LIST,
  SAVE_BUSINESS_DAY,
  SYNC_FAILED,
} from './actionTypes';
import { IBusinessDay } from './types';

export const initialState = {
  error: null,
  loaded: false,
  syncing: false,
  businessDayList: [],
  businessDay: null,
  businessDaySaved: false,
  businessDayLoaded: false,
  businessDaySyncing: false,
  businessDayDeleted: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_BUSINESS_DAY_LIST:
      return { ...state, error: null, syncing: true };
    case BUSINESS_DAY_LIST_LOADED:
      return {
        ...state,
        error: null,
        businessDayList: action.payload,
        syncing: false,
        loaded: true,
      };
    case BUSINESS_DAY_LOADED:
      return {
        ...state,
        error: null,
        businessDay: action.payload,
        businessDaySyncing: false,
        businessDayLoaded: true,
      };
    case LOAD_BUSINESS_DAY:
      return {
        ...state,
        error: null,
        businessDaySyncing: true,
        businessDayLoaded: false,
      };
    case SAVE_BUSINESS_DAY:
      return {
        ...state,
        error: null,
        businessDaySaved: false,
        businessDaySyncing: true,
      };
    case BUSINESS_DAY_SAVED:
      return {
        ...state,
        businessDay: action.payload,
        businessDaySaved: true,
        businessDaySyncing: false,
      };
    case BUSINESS_DAY_DELETED:
      const businessDayList = state.businessDayList.filter((item: IBusinessDay) => {
        return item.enterpriseUnitId !== action.payload;
      });

      return { ...state, businessDayList: businessDayList };
    case RESET_BUSINESS_DAY_LIST:
      return { ...state, error: null, businessDayList: [], loaded: false, syncing: false };
    case RESET_BUSINESS_DAY:
      return {
        ...state,
        businessDay: null,
        businessDaySaved: false,
        businessDayLoaded: false,
        businessDaySyncing: false,
        businessDayDeleted: false,
      };
    case SYNC_FAILED:
      return { ...state, syncing: false, businessDaySyncing: false, error: action.payload };
    default:
      return state;
  }
};
